import routerOptions0 from "/app/apps/nuxt-front/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.6.0_@types+node@26.6.5_db0@0.3.4_ioredis@5.11.1_magicast@0.5.5__yydqmtl2lfqrlsjrlnmspn2hz4/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/apps/nuxt-front/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}